import React from "react";
import ReactDOM from "react-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Paper, Typography } from "@material-ui/core";
import { useConfirmationDialog } from "frontend/src/ui/dialog";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { useDeactivatePageDevice } from "./model.new";
var useStyles = makeStyles(function (theme) { return ({
    deactivate: {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.error.dark,
        "&:hover": {
            backgroundColor: theme.palette.error.main,
        },
    },
}); });
export var DeactivateDevice = function (_a) {
    var id = _a.id;
    var classes = useStyles();
    var deactivate = useDeactivatePageDevice(id);
    var _b = useConfirmationDialog({
        open: false,
        onConfirm: deactivate.run,
        message: "Вы уверены, что хотите отвязать устройство?",
    }), open = _b.open, Dialog = _b.Dialog;
    return (React.createElement(React.Fragment, null,
        ReactDOM.createPortal(React.createElement(Dialog, null), document.body),
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Typography, { variant: "h5" }, "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E"),
            React.createElement(Box, { mt: 2 },
                React.createElement(Typography, null, "\u0412\u0441\u044F \u043C\u0443\u0437\u044B\u043A\u0430 \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0431\u0443\u0434\u0443\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0441 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430."),
                React.createElement(Typography, null, "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0432 \u0441\u0435\u0442\u0438. \u0415\u0441\u043B\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0435 \u0432 \u0441\u0435\u0442\u0438, \u0442\u043E \u043E\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u0432\u044F\u0437\u0430\u043D\u043E, \u043A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0441\u0435\u0442\u044C.")),
            React.createElement(Box, { mt: 1 },
                React.createElement(ButtonLoader, { isLoading: deactivate.isLoading, variant: "contained", color: "secondary", className: classes.deactivate, onClick: open }, "\u041E\u0442\u0432\u044F\u0437\u0430\u0442\u044C")))));
};
